export default {
  computed: {
    empty () {
      return !this.data.length
    },
    pagination () {
      return this.$store.state.app.pagination
    },
  },

  methods: {
    updateUrl () {
      const query = this.cleanObject(this.query)
      this.$router.push({ query }).catch(() => {})
    },
    handlePageChange (pageNum = 1) {
      this.query.page = pageNum
      this.fetchData()
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/tablePaginate.js